exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#map[data-v-45a071f2]{width:100%;height:95vh}@media screen and (max-width:768px){#map[data-v-45a071f2]{width:100%;height:75vh}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-45a071f2","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/LotMap.vue
// module id = 676
// module chunks = 0